import { actionTypes } from '../actions/actionTypes/reportActionTypes';

let initialState = {
  ReportData: [],
  postRportData: [],
  reportLoader: false,
  filterData: [],
  getFilterDataLoader: false,
  getReportsLoader: false,
  sendReportThroughMailLoader: false,
  SkillsList: [],
  skillsSearchLoader: false,
  isSkillsAvailable: false,
  ResumeUrls: {},
  showResumeLoader: false,
  isNoSOC: false,
};

/**
 * Redux reducers.
 * Used to update state in the store after actions are issued.
 */
export function reports(state = initialState, action) {
  // console.log(action);
  switch (action.type) {
    case actionTypes.GET_REPORTS_SUCCESS:
      return {
        ...state,
        ReportData: (action && action.cases) || [],
        reportLoader: false,
        getReportsLoader: false,
        postRportData: [],
      };

    case actionTypes.GET_REPORTS_FAILURE:
      return {
        ...state,
        ReportData: [],
        reportLoader: false,
        getReportsLoader: false,
        postRportData: [],
      };

    case actionTypes.GET_REPORTS_LOADER:
      return {
        ...state,
        ReportData: [],
        reportLoader: false,
        getReportsLoader: true,
        postRportData: [],
      };

    case actionTypes.POST_REPORTS_SUCCESS:
      return {
        ...state,
        postRportData: (action && action.cases) || [],
        reportLoader: false,
      };

    case actionTypes.POST_REPORTS_FAILURE:
      return {
        ...state,
        postRportData: [],
        reportLoader: false,
      };
    case actionTypes.SHOW_LOADER_REPORTS:
      return {
        ...state,
        reportLoader: true,
      };

    case actionTypes.SET_REPORTS_DATA:
      return {
        ...state,
        postRportData: [],
        // filterData: [],
      };

    case actionTypes.GET_FILTER_DATA_SUCCESS:
      return {
        ...state,
        filterData: action?.cases?.pxResults || [],
        getFilterDataLoader: false,
      };
    case actionTypes.GET_FILTER_DATA_LOADER:
      return {
        ...state,
        getFilterDataLoader: true,
      };
    case actionTypes.GET_FILTER_DATA_FAILURE:
      return {
        ...state,
        filterData: [],
        getFilterDataLoader: false,
      };
    case actionTypes.CLEAR_FILTER_DATA:
      return {
        ...state,
        filterData: [],
        postRportData:[]
      };
    case 'CLEAR_DATA':
      return {
        ...state,
        // filterData: [],
        postRportData:[]
      };
    case actionTypes.SEND_REPORT_THROUGH_MAIL_SUCCESS:
      return {
        ...state,
        sendReportThroughMailLoader: false,
      };
    case actionTypes.SEND_REPORT_THROUGH_MAIL_FAILURE:
      return {
        ...state,
        sendReportThroughMailLoader: false,
      };
    case actionTypes.SEND_REPORT_THROUGH_MAIL_LOADER:
      return {
        ...state,
        sendReportThroughMailLoader: true,
      };
    case actionTypes.EXPERTISE_SKILL_SEARCH_SUCCESS:
      return {
        ...state,
        SkillsList: action?.cases?.pxResults || [],
        isSkillsAvailable: action?.cases.value === 'true' ? true : false,
        skillsSearchLoader: false,
      };
    case actionTypes.EXPERTISE_SKILL_SEARCH_FAILURE:
      return {
        ...state,
        SkillsList: [],
        isSkillsAvailable: false,
        skillsSearchLoader: false,
      };
    case actionTypes.CLEAR_SKILLS_SEARCH:
      return {
        ...state,
        SkillsList: [],
        isSkillsAvailable: false,
        skillsSearchLoader: false,
      };
    case actionTypes.IS_NO_SKILLS_CERTS:
      return {
        ...state,
        isNoSOC: true,
        postRportData: [],
      };
    case actionTypes.IS_SKILLS_CERTS:
      return {
        ...state,
        isNoSOC: false,
      };
    case actionTypes.EXPERTISE_SKILL_SEARCH_LOADER:
      return {
        ...state,
        skillsSearchLoader: true,
      };
    case actionTypes.FETCH_EXPERTISE_RESUME_SUCCESS:
      return {
        ...state,
        ResumeUrls: action?.cases || {},
        showResumeLoader: false,
      };
    case actionTypes.FETCH_EXPERTISE_RESUME_FAILURE:
      return {
        ...state,
        ResumeFile: {},
        showResumeLoader: false,
      };
    case actionTypes.EXPERTISE_RESUME_LOADER:
      return {
        ...state,
        showResumeLoader: true,
      };
    default:
      return state;
  }
}
